export class HRGoal {
    id:                   string;
    hrConfigId:           string;
    ownerEmployeeId:      string;
    title:                string;
    description:          string;
    weight:               number = 1;
    active= true;
}